import { useEffect, useState } from "react";
// css
import "./listing.css";
// others
import { Button } from "@material-ui/core";
import FilterIcon from "assets/Images/icons/Filter-2.png";
import SwapIcon from "assets/Images/icons/Swap.png";
import defaultCardImg from "assets/Images/icons/defaultCardImg.png";
import SliderCard from "Components/sliderCard/SliderCard";
import shipIcon from "assets/Images/icons/shipBlue.png";
import peopleIcon from "assets/Images/icons/people.png";
import DoorIcon from "assets/Images/icons/door.png";
import BedIcon from "assets/Images/icons/bed.png";
import nextIcon from "assets/Images/icons/next.png";
import { data } from "./listingData";
import SearchDropdown from "Components/HomeComponent/SearchDropdown/SearchDropdown";
import { Close, ChevronRight } from "@material-ui/icons";
import CustomModal from "Utills/Model/CustomModel";
import { connect } from "react-redux";
import SiginInPopup from "Components/Popup/SiginInPopup/SiginInPopup";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

// All Listing page
const Listing = ({ current_user, stepPage, activeStep, steps }) => {
  //   let stepPage = props?.stepPage;
  // console.log(current_user)
  //============== more filter state ========================
  const [moreFilter, setMoreFilter] = useState(false);
  //===================== login modal dialog state ====================
  const [loginOpen, setLogin] = useState(false);
  //====================== filters state =============================
  const [filters, setFilters] = useState({
    priceRange: 15,
    lengthRange: 1,
    crewEnable: true,
    skipperEnable: false,
    petAllowed: true,
    eventsAllowed: true,
    cabins: 1,
    bathrooms: 1,
    beds: 1,
  });
  // active pagination state =======================
  const [activeTab, setActiveTab] = useState(0);
  //======================== listing data according to active pagination ==================
  const [listingsData, setListingsData] = useState([]);

  //===================== Set  listing data according to active pagination  on every time  when pagination index will change =========================
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "auto",
    });
    switch (activeTab) {
      case 0:
        setListingsData(data.slice(0, 20));
        break;
      //     case 1:
      //         if (data.length > prevLength) {
      //             setListingsData(data.slice(20, 20));
      //         }
      //         break;
      //     case 2:
      //         if (data.length > prevLength) {
      //             setListingsData(data.slice(20, 20));
      //             // setListingsData(data.slice(prevLength, prevLength + 20));
      //         }
      //         break;
      //     case 3:
      //         if (data.length > prevLength) {
      //             setListingsData(data.slice(20, 20));
      //             // setListingsData(data.slice(prevLength, prevLength + 14));
      //         }
      //         break;
      //     case 4:
      //         if (data.length > prevLength) {
      //             setListingsData(data.slice(20, 20));
      //             // setListingsData(data.slice(prevLength, prevLength + 20));
      //         }
      //         break;
      //     case "next":
      //         setListingsData(data.slice(0, prevLength + 18));
      default:
        return;
    }
  }, [activeTab]);

  //=================== update ranges ==================
  const updateRange = (value, type) => {
    if (type === "price") {
      let thumb = document.querySelector(".thumb1");
      let track = document.querySelector(".track-inner1");
      thumb.style.left = `${value - 2 < 2 ? value - 2 : value - 4}%`;
      thumb.style.transform = `translate(${value - 2},-50%)`;
      track.style.width = `${value - 2}%`;
      setFilters({
        ...filters,
        priceRange: value,
      });
    }
    if (type === "length") {
      let thumb = document.querySelector(".thumb2");
      let track = document.querySelector(".track-inner2");
      thumb.style.left = `${
        value + 9 - 2 < 2 ? value + 9 - 1 : value + 2 - 4
      }%`;
      thumb.style.transform = `translate(${value - 2},-50%)`;
      track.style.width = `${value + 2}%`;
      setFilters({
        ...filters,
        lengthRange: value,
      });
    }
  };

  return (
    <div className="cs_container my-5">
       <Helmet>
        <title>Cyan | Choose your yacht</title>
      </Helmet>
      <div className="mt-5 pt-5 mb-3 listing-page">
        <div className="row mt-3  justify-content-between align-items-center">
          <div className="col-md-4 col-12">
            
          </div>
          <div className="col-md-4 col-12 text-center">
          <h2 className="text-pr">Almost There Sailor...</h2>
        <p className="text-sec mb-3 ">
          All you have to do now is choose your ideal yacht and let us do the
          rest
        </p>
          </div>
          <div className="col-md-4 my-md-0 my-2 text-md-end text-center col-12">
          <p className="text-sec">
          If you need help with your trip
          </p>
          <Button
          component={Link}
          to="/contact"
            className="py-2 mt-2 mb-3"
            variant="contained"
            color="primary"
          >Contact us
          </Button>
          <br />
          <Button
            onClick={() => setMoreFilter(true)}
            className="py-3 filter-btn"
            endIcon={<img src={FilterIcon} alt="" />}
            variant="contained"
            color="secondary"
          >
            Advance Filter
          </Button>
          </div>
        </div>
        {/* <div className="d-flex">
          <div className="ms-auto text-right">
          <p className="text-sec">
          If you need help with your trip
          </p>
          <Button
            className="py-2"
            variant="contained"
            color="primary"
          >Contact us
          </Button>
          </div>
        </div> */}
        {/* <h2 className="text-pr mt-5 text-center">Almost There Sailor...</h2>
        <p className="text-sec mb-3 text-center">
          All you have to do now is choose your ideal yacht and let us do the
          rest
        </p> */}
        {/* <SearchDropdown read_only={true} /> */}
      </div>
      {/* <div className="row justify-content-end align-items-center">
        <div className="ml-auto max-content">
          <Button
            onClick={() => setMoreFilter(true)}
            className="py-3 filter-btn"
            endIcon={<img src={FilterIcon} alt="" />}
            variant="contained"
            color="secondary"
          >
            Advance Filter
          </Button>
        </div>
      </div> */}
      {/*  */}
      {stepPage && (
        <div className="cs-timeline">
          {[...Array(steps)].map((step, i) => {
            return (
              <div
                key={i}
                className={`${
                  activeStep === i ? "bg-sec text-white" : "bg-white"
                } cursor-auto cs-step create_yacht_cs_step`}
              >
                {i + 1}
              </div>
            );
          })}
        </div>
      )}
      {/*  */}
      <div className="w-100 pb-4 d-flex flex-wrap my-1 justify-content-between align-items-center">
        <h3 className="avail-yacht-head">
          Available Yacht ({" "}
          <span className="text-primary">
            {listingsData.length < 10
              ? "0" + listingsData.length
              : listingsData.length}
          </span>{" "}
          )
        </h3>
        <Button
          endIcon={<img src={SwapIcon} alt="" />}
          variant="text"
          color="inherit"
          className="text-capitalize text-secondary sort-btn"
        >
          Sort By
        </Button>
      </div>

      <div className="listings-container">
        <div className="row justify-content-start my-4">
          {listingsData.map((yacht, i) => (
            <div className="col-xl-3  col-md-4 col-sm-6 col-xs-12" key={i}>
              <SliderCard
                type="listingCard"
                user={current_user}
                openLoginModel={setLogin}
                linkEnabled={true}
                link={"/yachtDetail/" + yacht.id}
                data={{
                  id: i,
                  img: yacht.img || defaultCardImg,
                  title: yacht.title,
                  location: yacht.location,
                  price: yacht.price,
                  otherInfo: [
                    { yacht: "Motor Yacht", icon: shipIcon },
                    { yacht: "6", icon: peopleIcon },
                    { yacht: "2", icon: DoorIcon },
                    { yacht: "3", icon: BedIcon },
                  ],
                }}
              />
            </div>
          ))}
        </div>
      </div>
      <div className="d-flex justify-content-center align-items-center py-4 mb-3">
        <div className="cs-pagination-wrapper">
          <div
            onClick={() => setActiveTab(0)}
            tabIndex="0"
            className={`cs-pagination-item ${
              activeTab === 0 ? "active-paging" : ""
            }`}
          >
            <span>1</span>
          </div>
          <div
            onClick={() => setActiveTab(1)}
            tabIndex="0"
            className={`cs-pagination-item ${
              activeTab === 1 ? "active-paging" : ""
            }`}
          >
            <span>2</span>
          </div>
          <div
            onClick={() => setActiveTab(2)}
            tabIndex="0"
            className={`cs-pagination-item ${
              activeTab === 2 ? "active-paging" : ""
            }`}
          >
            <span>3</span>
          </div>
          <div
            onClick={() => setActiveTab(3)}
            tabIndex="0"
            className={`cs-pagination-item ${
              activeTab === 3 ? "active-paging" : ""
            }`}
          >
            <span>4</span>
          </div>
          <div
            onClick={() => setActiveTab(4)}
            tabIndex="0"
            className={`cs-pagination-item ${
              activeTab === 4 ? "active-paging" : ""
            }`}
          >
            <span>5</span>
          </div>
          <div
            onClick={() => setActiveTab("next")}
            tabIndex="0"
            className={`cs-pagination-item active-paging`}
          >
            <img src={nextIcon} alt="" />
          </div>
        </div>
      </div>
      <CustomModal openPopup={moreFilter} setOpenPopup={setMoreFilter}>
        <div className="more-filter-modal">
          {/* heade */}
          <div className="model-header">
            <div
              className="filter-model-close-btn"
              onClick={() => setMoreFilter(false)}
            >
              <Close />
            </div>
            <h4>Advance Filter</h4>
          </div>
          {/* body */}
          <div className="more-filter-pop-body">
            {/* <p className="fst-head">Price filtering </p> */}
            {/* <div className="range-slider-wrapper">
              <div className="wrap">
                <input
                  type="range"
                  className="cs-range"
                  min="0"
                  max="100"
                  // step="0.1"
                  value={filters.priceRange}
                  onChange={(e) => updateRange(e.target.value, "price")}
                />
                <div className="track">
                  <div className="track-inner track-inner1"></div>
                </div>
                <div className="thumb thumb1"></div>
              </div>
              <div className="prices">
                <div className="start-price">
                  <span>11 €</span>
                </div>
                <div className="end-price">
                  <span>750+ €</span>
                </div>
              </div>
              <div className="min-max-filter-wrap d-flex justify-content-center align-items-center">
                <span className="text-muted">Min</span>
                <input
                  className="min-max-input"
                  readOnly
                  value="50 €"
                  type="text"
                  placeholder="Min"
                />
                &nbsp;&nbsp;&nbsp;&nbsp; <span className="text-muted">Max</span>
                <input
                  className="min-max-input"
                  value={Math.floor(filters.priceRange) + " €"}
                  type="text"
                  placeholder="Max"
                />
                <button>
                  <ChevronRight />
                </button>
              </div>
            </div> */}
            <div className="d-flex mt-3 justify-content-between align-items-center">
              <span className="fw-bold">Cabins</span>
              <div className="d-flex ms-auto align-items-center">
                <span className="cursor-pointer user-select-none">
                  <svg tabIndex="0" className="outline-none" onClick={()=> setFilters({...filters, cabins: filters.cabins - 1 > 1 ? filters.cabins - 1 : 1})} width="24" height="24" viewBox="0 0 28 28" fill="none">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M14 0C6.26818 0 0 6.26818 0 14C0 21.7318 6.26818 28 14 28C21.7318 28 28 21.7318 28 14C28 6.26818 21.7318 0 14 0ZM8.90909 12.7273C8.57154 12.7273 8.24782 12.8614 8.00914 13.1C7.77045 13.3387 7.63636 13.6625 7.63636 14C7.63636 14.3375 7.77045 14.6613 8.00914 14.9C8.24782 15.1386 8.57154 15.2727 8.90909 15.2727H19.0909C19.4285 15.2727 19.7522 15.1386 19.9909 14.9C20.2295 14.6613 20.3636 14.3375 20.3636 14C20.3636 13.6625 20.2295 13.3387 19.9909 13.1C19.7522 12.8614 19.4285 12.7273 19.0909 12.7273H8.90909Z"
                      fill={filters.cabins > 1 ? "#3F8BBF" : "#212121"}
                    ></path>
                  </svg>
                </span>
                <div className="border-blue mx-2 text-pr rounded-3 px-2 py-1">{filters.cabins < 10 ? "0" + filters.cabins : filters.cabins}</div>
                <span tabIndex="0" onClick={()=> setFilters({...filters, cabins: filters.cabins + 1})} className="cursor-pointer user-select-none">
                  <svg width="24" height="24" viewBox="0 0 28 28" fill="none">
                    <path
                      d="M14 0C6.26875 0 0 6.26875 0 14C0 21.7312 6.26875 28 14 28C21.7312 28 28 21.7312 28 14C28 6.26875 21.7312 0 14 0ZM20 14.75C20 14.8875 19.8875 15 19.75 15H15V19.75C15 19.8875 14.8875 20 14.75 20H13.25C13.1125 20 13 19.8875 13 19.75V15H8.25C8.1125 15 8 14.8875 8 14.75V13.25C8 13.1125 8.1125 13 8.25 13H13V8.25C13 8.1125 13.1125 8 13.25 8H14.75C14.8875 8 15 8.1125 15 8.25V13H19.75C19.8875 13 20 13.1125 20 13.25V14.75Z"
                      fill="#3F8BBF"
                    ></path>
                  </svg>
                </span>
              </div>
              {/* <select className="cs-select-pop" name="" id="">
                <option value="">1</option>
                <option selected value="">
                  2
                </option>
                <option value="">3</option>
              </select> */}
            </div>
            <div className="d-flex mt-3 justify-content-between align-items-center">
              <span className="fw-bold">Bathrooms</span>

              <div className="d-flex ms-auto align-items-center">
                <span className="cursor-pointer user-select-none">
                  <svg tabIndex="0" className="outline-none" onClick={()=> setFilters({...filters, bathrooms: filters.bathrooms - 1 > 1 ? filters.bathrooms - 1 : 1})} width="24" height="24" viewBox="0 0 28 28" fill="none">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M14 0C6.26818 0 0 6.26818 0 14C0 21.7318 6.26818 28 14 28C21.7318 28 28 21.7318 28 14C28 6.26818 21.7318 0 14 0ZM8.90909 12.7273C8.57154 12.7273 8.24782 12.8614 8.00914 13.1C7.77045 13.3387 7.63636 13.6625 7.63636 14C7.63636 14.3375 7.77045 14.6613 8.00914 14.9C8.24782 15.1386 8.57154 15.2727 8.90909 15.2727H19.0909C19.4285 15.2727 19.7522 15.1386 19.9909 14.9C20.2295 14.6613 20.3636 14.3375 20.3636 14C20.3636 13.6625 20.2295 13.3387 19.9909 13.1C19.7522 12.8614 19.4285 12.7273 19.0909 12.7273H8.90909Z"
                      fill={filters.bathrooms > 1 ? "#3F8BBF" : "#212121"}
                    ></path>
                  </svg>
                </span>
                <div className="border-blue mx-2 text-pr rounded-3 px-2 py-1">{filters.bathrooms < 10 ? "0" + filters.bathrooms : filters.bathrooms}</div>
                <span tabIndex="0" onClick={()=> setFilters({...filters, bathrooms: filters.bathrooms + 1})} className="cursor-pointer user-select-none">
                  <svg width="24" height="24" viewBox="0 0 28 28" fill="none">
                    <path
                      d="M14 0C6.26875 0 0 6.26875 0 14C0 21.7312 6.26875 28 14 28C21.7312 28 28 21.7312 28 14C28 6.26875 21.7312 0 14 0ZM20 14.75C20 14.8875 19.8875 15 19.75 15H15V19.75C15 19.8875 14.8875 20 14.75 20H13.25C13.1125 20 13 19.8875 13 19.75V15H8.25C8.1125 15 8 14.8875 8 14.75V13.25C8 13.1125 8.1125 13 8.25 13H13V8.25C13 8.1125 13.1125 8 13.25 8H14.75C14.8875 8 15 8.1125 15 8.25V13H19.75C19.8875 13 20 13.1125 20 13.25V14.75Z"
                      fill="#3F8BBF"
                    ></path>
                  </svg>
                </span>
              </div>
              {/* <select className="cs-select-pop" name="" id="">
                <option value="">1</option>
                <option selected value="">
                  2
                </option>
                <option value="">3</option>
              </select> */}
            </div>
            <div className="d-flex mt-3 justify-content-between align-items-center">
              <span className="fw-bold">Crew</span>
              <div className="cs-switch-container">
                <label className="cs-switch" for="checkbox1">
                  <input
                    checked={filters.crewEnabled}
                    onChange={(e) =>
                      setFilters({ ...filters, crewEnable: e.target.checked })
                    }
                    className="switch-checkbox"
                    type="checkbox"
                    id="checkbox1"
                  />
                  <div className="cs-switch-slider switch-round"></div>
                </label>
              </div>
            </div>
            {/* <div className="d-flex mt-3 justify-content-between align-items-center">
              <span className="fw-bold">Skipper</span>
              <div className="cs-switch-container">
                <label className="cs-switch" for="checkbox2">
                  <input
                    checked={filters.skipperEnable}
                    onChange={(e) =>
                      setFilters({
                        ...filters,
                        skipperEnable: e.target.checked,
                      })
                    }
                    className="switch-checkbox"
                    type="checkbox"
                    id="checkbox2"
                  />
                  <div className="cs-switch-slider switch-round"></div>
                </label>
              </div>
            </div> */}
            <div className="d-flex mt-3 justify-content-between align-items-center">
              <span className="fw-bold">Beds</span>

              {/* <select className="cs-select-pop" name="" id="">
                <option value="">1</option>
                <option selected value="">
                  2
                </option>
                <option value="">3</option>
              </select> */}

              <div className="d-flex ms-auto align-items-center">
                <span className="cursor-pointer user-select-none">
                  <svg tabIndex="0" className="outline-none" onClick={()=> setFilters({...filters, beds: filters.beds - 1 > 1 ? filters.beds - 1 : 1})} width="24" height="24" viewBox="0 0 28 28" fill="none">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M14 0C6.26818 0 0 6.26818 0 14C0 21.7318 6.26818 28 14 28C21.7318 28 28 21.7318 28 14C28 6.26818 21.7318 0 14 0ZM8.90909 12.7273C8.57154 12.7273 8.24782 12.8614 8.00914 13.1C7.77045 13.3387 7.63636 13.6625 7.63636 14C7.63636 14.3375 7.77045 14.6613 8.00914 14.9C8.24782 15.1386 8.57154 15.2727 8.90909 15.2727H19.0909C19.4285 15.2727 19.7522 15.1386 19.9909 14.9C20.2295 14.6613 20.3636 14.3375 20.3636 14C20.3636 13.6625 20.2295 13.3387 19.9909 13.1C19.7522 12.8614 19.4285 12.7273 19.0909 12.7273H8.90909Z"
                      fill={filters.beds > 1 ? "#3F8BBF" : "#212121"}
                    ></path>
                  </svg>
                </span>
                <div className="border-blue mx-2 text-pr rounded-3 px-2 py-1">{filters.beds < 10 ? "0" + filters.beds : filters.beds}</div>
                <span tabIndex="0" onClick={()=> setFilters({...filters, beds: filters.beds + 1})} className="cursor-pointer user-select-none">
                  <svg width="24" height="24" viewBox="0 0 28 28" fill="none">
                    <path
                      d="M14 0C6.26875 0 0 6.26875 0 14C0 21.7312 6.26875 28 14 28C21.7312 28 28 21.7312 28 14C28 6.26875 21.7312 0 14 0ZM20 14.75C20 14.8875 19.8875 15 19.75 15H15V19.75C15 19.8875 14.8875 20 14.75 20H13.25C13.1125 20 13 19.8875 13 19.75V15H8.25C8.1125 15 8 14.8875 8 14.75V13.25C8 13.1125 8.1125 13 8.25 13H13V8.25C13 8.1125 13.1125 8 13.25 8H14.75C14.8875 8 15 8.1125 15 8.25V13H19.75C19.8875 13 20 13.1125 20 13.25V14.75Z"
                      fill="#3F8BBF"
                    ></path>
                  </svg>
                </span>
              </div>
            </div>
            <div className="d-flex mt-3 justify-content-between align-items-center">
              <span className="fw-bold">Pets allowed</span>
              <div className="cs-switch-container">
                <label className="cs-switch" for="checkbox3">
                  <input
                    checked={filters.petAllowed}
                    onChange={(e) =>
                      setFilters({ ...filters, petAllowed: e.target.checked })
                    }
                    className="switch-checkbox"
                    type="checkbox"
                    id="checkbox3"
                  />
                  <div className="cs-switch-slider switch-round"></div>
                </label>
              </div>
            </div>
            <div className="d-flex mt-3 justify-content-between align-items-center">
              <span className="fw-bold">Events allowed</span>
              <div className="cs-switch-container">
                <label className="cs-switch" for="checkbox4">
                  <input
                    checked={filters.eventsAllowed}
                    onChange={(e) =>
                      setFilters({
                        ...filters,
                        eventsAllowed: e.target.checked,
                      })
                    }
                    className="switch-checkbox"
                    type="checkbox"
                    id="checkbox4"
                  />
                  <div className="cs-switch-slider switch-round"></div>
                </label>
              </div>
            </div>
            {/* length */}
            <h5 className="fw-bold mt-3 mb-2">Length</h5>
            <div className="range-slider-wrapper pb-2">
              <div className="wrap">
                <input
                  type="range"
                  className="cs-range"
                  min="0"
                  max="10"
                  // step="0.1"
                  value={filters.lengthRange}
                  onChange={(e) => updateRange(e.target.value, "length")}
                />
                <div className="track">
                  <div className="track-inner track-inner2"></div>
                </div>
                <div className="thumb thumb2"></div>
              </div>
              <div className="prices">
                <div className="start-price">
                  <span>1</span>
                </div>
                <div className="end-price">
                  <span>10</span>
                </div>
              </div>
              <div className="min-max-filter-wrap d-flex ps-3 mb-3 justify-content-start align-items-center">
                <span className="text-muted me-2">Min</span>
                <input
                  className="min-max-input"
                  value={Math.floor(filters.lengthRange) + " m"}
                  type="text"
                  placeholder="Max"
                />
              </div>
            </div>
            {/* <hr /> */}
            {/* <h5 className="fw-bold mt-3 pt-2">Amenities</h5>
            <div className="d-flex flex-wrap pb-3 check-boxes-wrapper">
              <div className="cs-chk-box">
                <label className="checkbox-button">
                  <input
                    checked="checked"
                    type="checkbox"
                    className="checkbox-button__input"
                    id=""
                    name=""
                  />
                  <span className="checkbox-button__control"></span>
                  <span className="checkbox-button__label text-sec">
                    Outdoor pool
                  </span>
                </label>
              </div>
              <div className="cs-chk-box">
                <label className="checkbox-button">
                  <input
                    type="checkbox"
                    className="checkbox-button__input"
                    id=""
                    name=""
                  />
                  <span className="checkbox-button__control"></span>
                  <span className="checkbox-button__label text-sec">
                    Indoor pool
                  </span>
                </label>
              </div>
              <div className="cs-chk-box">
                <label className="checkbox-button">
                  <input
                    type="checkbox"
                    className="checkbox-button__input"
                    id=""
                    name=""
                  />
                  <span className="checkbox-button__control"></span>
                  <span className="checkbox-button__label text-sec">
                    Helipad
                  </span>
                </label>
              </div>
              <div className="cs-chk-box">
                <label className="checkbox-button">
                  <input
                    type="checkbox"
                    className="checkbox-button__input"
                    id=""
                    name=""
                  />
                  <span className="checkbox-button__control"></span>
                  <span className="checkbox-button__label text-sec">Gym</span>
                </label>
              </div>
              <div className="cs-chk-box">
                <label className="checkbox-button">
                  <input
                    type="checkbox"
                    className="checkbox-button__input"
                    id=""
                    name=""
                  />
                  <span className="checkbox-button__control"></span>
                  <span className="checkbox-button__label text-sec">
                    Cinema
                  </span>
                </label>
              </div>
              <div className="cs-chk-box">
                <label className="checkbox-button">
                  <input
                    type="checkbox"
                    className="checkbox-button__input"
                    id=""
                    name=""
                  />
                  <span className="checkbox-button__control"></span>
                  <span className="checkbox-button__label text-sec">
                    Jacuzzi
                  </span>
                </label>
              </div>
            </div> */}
            {/* <hr /> */}
            {/* Extras */}
            {/* <h5 className="fw-bold mt-3 pt-2">Extras</h5>
            <div className="d-flex flex-wrap pb-3 check-boxes-wrapper">
              <div className="cs-chk-box">
                <label className="checkbox-button">
                  <input
                    checked="checked"
                    type="checkbox"
                    className="checkbox-button__input"
                    id=""
                    name=""
                  />
                  <span className="checkbox-button__control"></span>
                  <span className="checkbox-button__label text-sec">SUP</span>
                </label>
              </div>
              <div className="cs-chk-box">
                <label className="checkbox-button">
                  <input
                    type="checkbox"
                    className="checkbox-button__input"
                    id=""
                    name=""
                  />
                  <span className="checkbox-button__control"></span>
                  <span className="checkbox-button__label text-sec">Kayak</span>
                </label>
              </div>
              <div className="cs-chk-box">
                <label className="checkbox-button">
                  <input
                    type="checkbox"
                    className="checkbox-button__input"
                    id=""
                    name=""
                  />
                  <span className="checkbox-button__control"></span>
                  <span className="checkbox-button__label text-sec">
                    Drone Photography Coverage
                  </span>
                </label>
              </div>
              <div className="cs-chk-box">
                <label className="checkbox-button">
                  <input
                    type="checkbox"
                    className="checkbox-button__input"
                    id=""
                    name=""
                  />
                  <span className="checkbox-button__control"></span>
                  <span className="checkbox-button__label text-sec">
                    Yacht Slide
                  </span>
                </label>
              </div>
              <div className="cs-chk-box">
                <label className="checkbox-button">
                  <input
                    type="checkbox"
                    className="checkbox-button__input"
                    id=""
                    name=""
                  />
                  <span className="checkbox-button__control"></span>
                  <span className="checkbox-button__label text-sec">
                    Yacht Golf
                  </span>
                </label>
              </div>
              <div className="cs-chk-box">
                <label className="checkbox-button">
                  <input
                    type="checkbox"
                    className="checkbox-button__input"
                    id=""
                    name=""
                  />
                  <span className="checkbox-button__control"></span>
                  <span className="checkbox-button__label text-sec">
                    Inflatable Climbing wall
                  </span>
                </label>
              </div>
              <div className="cs-chk-box">
                <label className="checkbox-button">
                  <input
                    type="checkbox"
                    className="checkbox-button__input"
                    id=""
                    name=""
                  />
                  <span className="checkbox-button__control"></span>
                  <span className="checkbox-button__label text-sec">
                    Sky Air foilboard
                  </span>
                </label>
              </div>
              <div className="cs-chk-box">
                <label className="checkbox-button">
                  <input
                    type="checkbox"
                    className="checkbox-button__input"
                    id=""
                    name=""
                  />
                  <span className="checkbox-button__control"></span>
                  <span className="checkbox-button__label text-sec">
                    Jetski
                  </span>
                </label>
              </div>
              <div className="cs-chk-box">
                <label className="checkbox-button">
                  <input
                    type="checkbox"
                    className="checkbox-button__input"
                    id=""
                    name=""
                  />
                  <span className="checkbox-button__control"></span>
                  <span className="checkbox-button__label text-sec">
                    Jumping water bag
                  </span>
                </label>
              </div>
              <div className="cs-chk-box">
                <label className="checkbox-button">
                  <input
                    type="checkbox"
                    className="checkbox-button__input"
                    id=""
                    name=""
                  />
                  <span className="checkbox-button__control"></span>
                  <span className="checkbox-button__label text-sec">
                    Inflatable pool
                  </span>
                </label>
              </div>
              <div className="cs-chk-box">
                <label className="checkbox-button">
                  <input
                    type="checkbox"
                    className="checkbox-button__input"
                    id=""
                    name=""
                  />
                  <span className="checkbox-button__control"></span>
                  <span className="checkbox-button__label text-sec">
                    IMassage session
                  </span>
                </label>
              </div>
              <div className="cs-chk-box">
                <label className="checkbox-button">
                  <input
                    type="checkbox"
                    className="checkbox-button__input"
                    id=""
                    name=""
                  />
                  <span className="checkbox-button__control"></span>
                  <span className="checkbox-button__label text-sec">
                    Inflatable fighting surface
                  </span>
                </label>
              </div>
              <div className="cs-chk-box">
                <label className="checkbox-button">
                  <input
                    type="checkbox"
                    className="checkbox-button__input"
                    id=""
                    name=""
                  />
                  <span className="checkbox-button__control"></span>
                  <span className="checkbox-button__label text-sec">
                    Yoga session
                  </span>
                </label>
              </div>
              <div className="cs-chk-box">
                <label className="checkbox-button">
                  <input
                    type="checkbox"
                    className="checkbox-button__input"
                    id=""
                    name=""
                  />
                  <span className="checkbox-button__control"></span>
                  <span className="checkbox-button__label text-sec">
                    Gym session
                  </span>
                </label>
              </div>
              <div className="cs-chk-box">
                <label className="checkbox-button">
                  <input
                    type="checkbox"
                    className="checkbox-button__input"
                    id=""
                    name=""
                  />
                  <span className="checkbox-button__control"></span>
                  <span className="checkbox-button__label text-sec">
                    Wakeboard
                  </span>
                </label>
              </div>
              <div className="cs-chk-box">
                <label className="checkbox-button">
                  <input
                    type="checkbox"
                    className="checkbox-button__input"
                    id=""
                    name=""
                  />
                  <span className="checkbox-button__control"></span>
                  <span className="checkbox-button__label text-sec">
                    Parasailing
                  </span>
                </label>
              </div>
            </div> */}
          </div>

          {/* footer */}
          <div className="model-footer d-flex justify-content-between align-items-center">
            <button className="text-sec bg-white p-2 fw-bold text-decoration-underline">
              Clear all
            </button>
            <button className="text-white dark-btn">Apply</button>
          </div>
        </div>
      </CustomModal>

      {/* login model popUP */}
      <CustomModal openPopup={loginOpen} setOpenPopup={setLogin}>
        <SiginInPopup closeModel={setLogin} />
      </CustomModal>
    </div>
  );
};

// REDUX CONFIGS
const mapStateToProps = (store) => ({
  current_user: store.current_user,
});

export default connect(mapStateToProps, null)(Listing);
